import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyC2r1V-XEx-n70YGMehT2I6KwE55YL-kU8",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: "typebotlogin-be2a9",
  storageBucket: "typebotlogin-be2a9.firebasestorage.app",
  messagingSenderId: "632642080309",
  appId: "1:632642080309:web:3eb6dc690ca13dcaed6b7c",
  measurementId: "G-MFLWCYDYGY"
};

const app = initializeApp(firebaseConfig);

export { app };
